import React from 'react';

import './ModalSelectionItem.scss';

export const ModalSelectionItem = ({ children }) => {
  return (
    <div styleName="ccf-modal-input-item">
      {children}
    </div>
  );
};

export default ModalSelectionItem;
